<template>
    <div :class="$style.purchase">
        <div
            v-if="subtitle"
            :class="$style.with_subtitle"
        >
            <Typography
                type="label"
                size="m"
                :responsive="false"
            >
                {{ title }}
            </Typography>
            <Typography
                :class="$style.subtitle"
                type="label"
                size="xs"
                :responsive="false"
            >
                {{ subtitle }}
            </Typography>
        </div>
        <Typography
            v-else
            type="label"
            size="m"
        >
            {{ title }}
        </Typography>
    </div>
</template>
<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'

defineProps<{
    title: string
    subtitle?: string
}>()
</script>

<style module>
.purchase {
    margin: 32px 0;
    padding: 12px;
    border-radius: 12px;
    background-color: var(--carbon-400);
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
}

.purchase::before {
    content: '';
    box-sizing: border-box;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background: var(--white);
    border: 10px solid var(--purple-400);
}

.with_subtitle {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.subtitle {
    color: var(--white-40);
}
</style>
